<div class="modal-header">
    <h2
        class="modal-title"
        id="exampleModalLabel">
        Delete {{ this.country.countryName }}
    </h2>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">Are you sure you want to delete {{ this.country.countryName }} ?</div>

<div class="modal-footer">
    <button
        class="button button--danger"
        (click)="deleteCountry()">
        Delete
    </button>
    <button
        type="button"
        class="button button--outline"
        (click)="activeModal.dismiss()">
        Cancel
    </button>
</div>
